/** @flow */
import fetch from 'utils/fetch';
import { INIT_ACTION_TYPE } from '../store';

import { setSubscriptions } from 'actions/auth';
import { toggleFlag } from 'actions/flags';

export default store => next => async action => {
  const { type } = action;
  const { dispatch } = store;

  if (type === INIT_ACTION_TYPE) {
    try {
      const json = await (await fetch(
        '/w/api/subscriptions'
      )).json();

      const { subscriptions } = json;
      const hasSubscription =
        subscriptions.filter(({ active }) => active).length > 0;

      dispatch(setSubscriptions(subscriptions));
      dispatch(toggleFlag('hasSubscription', hasSubscription));
    } catch (e) {
      console.log('Unauthorized access of subscriptions', e);
    }
  }

  next(action);
};



// WEBPACK FOOTER //
// ./utils/auth.middleware.js